const translations = {
    apiError: 'Something went wrong. Please try again.'
};

export default translations;
